import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { CustomerListItem } from '../models/customer-list-item';

export class CustomerListApi {
    constructor(protected baseUrl: string) {}

    public getCustomers(search: URLSearchParams): Promise<ApiResult<PaginatedResponse<CustomerListItem>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/customers`, { params: search }),
            response => response.data
        );
    }
}
